import toNumber from 'lodash/toNumber'
import isNaN from 'lodash/isNaN'
import isBoolean from 'lodash/isBoolean'
/**
 * This function converts anything to number.
 * If the value looks a like a number it will convert correctly,
 * If the value is not a number, it will fall back to zero
 *
 * Under the hood it uses toNumber from lodash, but fallback to zero if IsNan
 */
export const toValidNumber = (value: any): number => {
  if (!isFinite(value)) return 0
  if (isBoolean(value)) return 0

  const num = toNumber(value)

  if (isNaN(num)) return 0

  //
  //

  return num
}
